import * as React from 'react'
import { Input } from 'reactstrap'
import { isEqual } from 'lodash'

interface ICheckboxProps {
  input: any
  options: Option[]
  label: string
  onChange: (thing: any) => {}
}
interface Option {
  isChecked: boolean
  name: string
}
export const getDropDownOptions = (constant: any, initial: any) => {
  const options = []

  for (const key in constant) {
    const option = {
      value: key,
      label: constant[key],
      checked: false
    }
    if (isEqual(key, initial)) {
      option.checked = true
    }
    options.push(option)
  }

  return options
}
const Checkbox: React.FC<ICheckboxProps> = props => {
  // *variable declarations
  const checkboxGroup = () => {
    const { options, input } = props
    const newValues = input.value
    if (newValues.length > 0) {
      input.value = !newValues[0].hasOwnProperty('id')
        ? newValues
        : newValues.map((current: any) => current.id)
    }
    return options.map((option: any, index: number) => {
      return (
        <>
          <label className="m-0" key={index}>
            <Input
              name={`${input.name}`}
              value={+option.value}
              type="checkbox"
              defaultChecked={option.isChecked}
              checked={input.value.indexOf(+option.value) !== -1}
              onChange={(event: any) => {
                const newValue = [...input.value]
                if (newValue.indexOf(+option.value) === -1) {
                  newValue.push(+option.value)
                } else {
                  newValue.splice(newValue.indexOf(+option.value), 1)
                }
                return props.onChange(newValue)
              }}
            />
            <span className="fa fa-check"></span>&nbsp;
            {option.label}
          </label>
        </>
      )
    })
  }
  return <div>{checkboxGroup()}</div>
}
export default Checkbox
